export const GET_DOCTOR_PATIENTS_LIST = 'doctorPatients/GET_DOCTOR_PATIENTS_LIST';
export const CHANGE_DOCTOR_PATIENTS_FILTER = 'doctorPatients/CHANGE_DOCTOR_PATIENTS_FILTER';
export const CHANGE_DOCTOR_PATIENTS_ORDER = 'doctorPatients/CHANGE_DOCTOR_PATIENTS_ORDER';
export const GET_DOCTOR_PATIENTS_LIST_FOR_DROPDOWN = 'doctorPatients/GET_DOCTOR_PATIENTS_LIST_FOR_DROPDOWN';

export function getDoctorPatientsList({
    offset, limit, filter, order,
}) {
    return {
        type: GET_DOCTOR_PATIENTS_LIST,
        httpRequest: {
            method: 'post',
            path: '/doctorPatients/list',
            data: {
                offset,
                limit,
                filter,
                order,
            },
        },
        offset,
        limit,
    };
}

export function getPatientsListForDropdown(search, filter = {}) {
    const {assigneeId} = filter;
    return {
        type: GET_DOCTOR_PATIENTS_LIST_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/doctorPatients/list/dropdown',
            params: {
                search,
                assigneeId,
            },
        },
    };
}

export function changeDoctorPatientsFilter(filter) {
    return {
        type: CHANGE_DOCTOR_PATIENTS_FILTER,
        filter,
    };
}

export function changeDoctorPatientsOrder(order) {
    return {
        type: CHANGE_DOCTOR_PATIENTS_ORDER,
        order,
    };
}



// WEBPACK FOOTER //
// ./src/reducers/doctorPatients/doctorPatientsActions.js